import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './AgendaCalendario.css';

  const AgendaCalendario = ({ usuarioId, onClose, modoSoloLectura = false, tituloPersonalizado = 'Mi Agenda Personal' }) => {
  const [eventos, setEventos] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mensaje, setMensaje] = useState(null);
  const [tipoMensaje, setTipoMensaje] = useState('success');
  const [contadorCaracteres, setContadorCaracteres] = useState(160);
  
  // Estados para modales
  const [modalEvento, setModalEvento] = useState(false);
  const [modalVerEvento, setModalVerEvento] = useState(false);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  
  // Estados para formulario
  const [formData, setFormData] = useState({
    titulo: 'Ocupado', // Valor por defecto
    descripcion: '',
    dia: '',
    hora: '',
    fecha: ''
  });

  // API Base URL
  const API_BASE = process.env.REACT_APP_AGENDA_URL;

  // Generar pr�ximos 3 d�as
  const generarProximosDias = () => {
    const dias = [];
    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
    
    for (let i = 0; i < 3; i++) {
      const fecha = new Date();
      fecha.setDate(fecha.getDate() + i);
      
      dias.push({
        nombre: diasSemana[fecha.getDay()],
        fecha: fecha,
        fechaStr: fecha.toISOString().split('T')[0],
        diaMes: `${fecha.getDate().toString().padStart(2, '0')}/${(fecha.getMonth() + 1).toString().padStart(2, '0')}`
      });
    }
    return dias;
  };

  // Generar horas cada 30 minutos
  const generarHoras = () => {
    const horas = [];
    for (let i = 0; i < 24; i++) {
      horas.push(`${i.toString().padStart(2, '0')}:00`);
      horas.push(`${i.toString().padStart(2, '0')}:30`);
    }
    return horas;
  };

  const diasMostrar = generarProximosDias();
  const horas = generarHoras();

  // Cargar eventos del usuario
  const cargarEventos = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE}/get.php`, {
        params: {
          usuario_id: usuarioId,
          proximos_dias: true
        }
      });
      
      if (response.data.status === 'success') {
        setEventos(response.data.data.records || []);
      } else {
        setEventos([]);
      }
    } catch (error) {
      console.error('Error al cargar eventos:', error);
      setEventos([]);
    } finally {
      setLoading(false);
    }
  }, [usuarioId]);

  // Efecto para cargar eventos al montar componente
  useEffect(() => {
    if (usuarioId) {
      cargarEventos();
    }
  }, [usuarioId, cargarEventos]);

  // Funci�n para normalizar hora (quitar segundos)
  const normalizarHora = (hora) => {
    if (!hora) return '';
    return hora.substring(0, 5);
  };

  // Obtener eventos para una celda espec�fica
  const obtenerEventosCelda = (fechaStr, hora) => {
    return eventos.filter(evento => {
      const horaEventoNormalizada = normalizarHora(evento.hora);
      return evento.fecha === fechaStr && horaEventoNormalizada === hora;
    });
  };

  // Mostrar mensaje temporal
  const mostrarMensaje = (texto, tipo = 'success') => {
    setMensaje(texto);
    setTipoMensaje(tipo);
    setTimeout(() => setMensaje(null), 5000);
  };

// Calcular la hora mínima habilitada para hoy (ahora + 30 min, redondeado al bloque de 30)
const calcularHoraMinima = () => {
  const ahora = new Date();
  const mins = ahora.getMinutes();
  if (mins < 30) {
    ahora.setMinutes(30, 0, 0);
  } else {
    ahora.setHours(ahora.getHours() + 1, 0, 0, 0);
  }
  return `${ahora.getHours().toString().padStart(2, '0')}:${ahora.getMinutes().toString().padStart(2, '0')}`;
};

// Determinar si una celda está habilitada para edición
const esCeldaHabilitada = (fechaStr, hora) => {
  const hoy = new Date().toISOString().split('T')[0];
  if (fechaStr !== hoy) return true; // Días futuros: siempre habilitado
  return hora >= calcularHoraMinima();  // Hoy: solo desde hora mínima en adelante
};

// Abrir modal para nuevo evento
const abrirModal = (dia, hora, fecha) => {
  if (!modoEdicion || modoSoloLectura) return;

  // Bloquear si la celda es de hora pasada (solo aplica en modo edición)
  if (!esCeldaHabilitada(fecha, hora)) return;
 
  setContadorCaracteres(160); // Resetear contador
  setFormData({
      titulo: 'Ocupado', // Valor por defecto
      descripcion: '',
      dia: dia,
      hora: hora,
      fecha: fecha
    });
    setModalEvento(true);
  };

  // Cerrar modal de evento
  const cerrarModal = () => {
    setModalEvento(false);
    setContadorCaracteres(160); // Resetear contador
    setFormData({
      titulo: 'Ocupado', // Valor por defecto
      descripcion: '',
      dia: '',
      hora: '',
      fecha: ''
    });
  };

  // Ver detalles de evento
  const verEvento = (evento) => {
    setEventoSeleccionado(evento);
    setModalVerEvento(true);
  };

  // Cerrar modal de ver evento ? AGREGAR ESTA FUNCI�N AQU�
  const cerrarModalVer = () => {
    setModalVerEvento(false);
    setEventoSeleccionado(null);
  };

  // Manejar cambios en formulario
  const manejarCambio = (e) => {
    const { name, value } = e.target;
    
  // Si es el campo descripci�n, limitar a 160 caracteres
  if (name === 'descripcion') {
    const limitedValue = value.slice(0, 160);
    setFormData(prev => ({
      ...prev,
      [name]: limitedValue
    }));
    setContadorCaracteres(160 - limitedValue.length);
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }
};
  // Agregar nuevo evento
  const agregarEvento = async (e) => {
    e.preventDefault();
    
    if (!formData.titulo.trim()) {
      mostrarMensaje('El t�tulo es obligatorio', 'error');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/agenda_api.php`, {
        action: 'agregar_evento',
        ...formData,
        usuario_id: usuarioId
      });

      if (response.data.success) {
        mostrarMensaje('Evento agregado exitosamente', 'success');
        cerrarModal();
        await cargarEventos(); // Recargar eventos
      } else {
        mostrarMensaje('Error al agregar evento', 'error');
      }
    } catch (error) {
      console.error('Error al agregar evento:', error);
      mostrarMensaje('Error al agregar evento', 'error');
    }
  };

  // Eliminar evento
  const eliminarEvento = async () => {
    if (!eventoSeleccionado || !window.confirm('�Est�s seguro de que deseas eliminar este evento?')) {
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/agenda_api.php`, {
        action: 'eliminar_evento',
        evento_id: eventoSeleccionado.id,
        usuario_id: usuarioId
      });

      if (response.data.success) {
        mostrarMensaje('Evento eliminado exitosamente', 'success');
        cerrarModalVer();
        await cargarEventos(); // Recargar eventos
      } else {
        mostrarMensaje('Error al eliminar evento', 'error');
      }
    } catch (error) {
      console.error('Error al eliminar evento:', error);
      mostrarMensaje('Error al eliminar evento', 'error');
    }
  };

  // Toggle modo edici�n
  const toggleEditMode = () => {
    setModoEdicion(!modoEdicion);
  };

  // Obtener fecha y hora actual
  const fechaActual = new Date();
  const fechaServidor = fechaActual.toISOString().split('T')[0];

  if (loading) {
    return (
      <div className="agenda-loading">
        <div className="loading-spinner"></div>
        <p>Cargando agenda...</p>
      </div>
    );
  }

  return (
    <div className="agenda-calendario-container">
      {/* Mensaje de notificaci�n */}
      {mensaje && (
        <div className={`mensaje ${tipoMensaje}`}>
          {mensaje}
        </div>
      )}

      {/* Header */}
      <div className="header">
        <div className="title-section">
          <h1>{tituloPersonalizado}</h1>
          <div className="subtitle">
            {fechaActual.toLocaleDateString('es-ES', { 
              month: 'long', 
              year: 'numeric' 
            })}
          </div>
        </div>
	<div className="btn-group-header">
          {!modoSoloLectura && (
            <button className={`btn-modern ${modoEdicion ? 'active' : ''}`} onClick={toggleEditMode}>
              {modoEdicion ? '?? Salir' : '?? Editar'}
            </button>
          )}
          <button className="btn-modern btn-close" onClick={onClose}>
            ?? Cerrar
          </button>
        </div>
      </div>

      {/* Calendario */}
      <div className="calendario">
        <div className="calendario-header">
          <div>Hora</div>
          {diasMostrar.map((dia, index) => (
            <div key={index}>
              {dia.nombre}<br />
              <small>{dia.diaMes}</small>
            </div>
          ))}
        </div>
        
        <div className="calendario-body">
          {horas.map((hora, horaIndex) => (
            <div key={horaIndex} className="hora-row">
              <div className="hora-label">{hora}</div>
              {diasMostrar.map((dia, diaIndex) => {
                const eventosCelda = obtenerEventosCelda(dia.fechaStr, hora);
                return (
<div 
  key={diaIndex} 
  className={`dia-cell ${(modoEdicion && !modoSoloLectura) ? 'editable' : ''} ${(modoEdicion && !modoSoloLectura && !esCeldaHabilitada(dia.fechaStr, hora)) ? 'cell-disabled' : ''}`}
  onClick={() => abrirModal(dia.nombre, hora, dia.fechaStr)}
>
                    {eventosCelda.map((evento, eventoIndex) => (
                      <div 
                        key={eventoIndex} 
                        className="evento"
                        onClick={(e) => {
                          e.stopPropagation();
                          verEvento(evento);
                        }}
                      >
                        {evento.titulo}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Modal para agregar evento */}
      {modalEvento && (
        <div className="modal" onClick={(e) => e.target.classList.contains('modal') && cerrarModal()}>
          <div className="modal-content">
            <h3>Nuevo Evento</h3>
            <form onSubmit={agregarEvento}>
              <div className="form-group">
                <label>T�tulo del Evento *</label>
                <select
                  name="titulo"
                  value={formData.titulo}
                  onChange={manejarCambio}
                  required                  
                >
                  <option value="Ocupado">Ocupado</option>
                  <option value="Streaming">Streaming</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Descripci�n</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={manejarCambio}
                  rows="4"
                  placeholder="Descripci�n opcional del evento"
                  maxLength="160"
                />
                <div className="contador-caracteres" style={{
                  textAlign: 'right',
                  fontSize: '12px',
                  color: contadorCaracteres < 20 ? '#ff4444' : '#666',
                  marginTop: '5px'
                }}>
                  {contadorCaracteres} caracteres restantes
                </div>
              </div>
              
              <div className="btn-group">
                <button type="button" className="btn-modal btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn-modal btn-primary">
                  Crear Evento
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal para ver evento */}
      {modalVerEvento && eventoSeleccionado && (
        <div className="modal" onClick={(e) => e.target.classList.contains('modal') && cerrarModalVer()}>
          <div className="modal-content">
            <h3>Detalles del Evento</h3>
            <div className="evento-detalles">
              <p><strong>T�tulo:</strong> {eventoSeleccionado.titulo}</p>
              <p><strong>Descripci�n:</strong> {eventoSeleccionado.descripcion || 'Sin descripci�n'}</p>
              <p><strong>D�a:</strong> {eventoSeleccionado.dia}</p>
              <p><strong>Hora:</strong> {eventoSeleccionado.hora}</p>
              <p><strong>Fecha:</strong> {eventoSeleccionado.fecha}</p>
            </div>
<div className="btn-group">
  <button type="button" className="btn-modal btn-secondary" onClick={cerrarModalVer}>
    Cerrar
  </button>
  {!modoSoloLectura && (
    <button type="button" className="btn-modal btn-primary" onClick={eliminarEvento}>
      Eliminar
    </button>
  )}
</div>
          </div>
        </div>
      )}
     
    </div>
  );
};

export default AgendaCalendario;